import { pxToRem } from '../../../../utils';
export var accordionContentStyles = {
  root: function root(_ref) {
    var props = _ref.props;
    return Object.assign({
      display: 'none',
      verticalAlign: 'middle'
    }, props.active && {
      display: 'block'
    }, {
      marginInlineStart: "" + pxToRem(20)
    });
  }
};
//# sourceMappingURL=accordionContentStyles.js.map
